import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) =>
    css`
      width: 100%;
      max-width: ${theme.layout.spacing(75)};
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(3)};

      h1 {
        font-size: ${theme.typography.sizes.title1};
        font-weight: ${theme.typography.weight.regular};

        strong {
          font-weight: ${theme.typography.weight.extraBold};
        }
      }

      p {
        font-size: ${theme.typography.sizes.body1};
      }

      div {
        display: flex;
        flex-direction: column;
      }
    `}
`;
